export enum Consent {
  NECESSARY = 0,
  /** Functional */
  ANALYTICS = 1,
  PERFORMANCE = 2,
  /** Advertising */
  ADVERTISING = 3,
}
